export default {
    computed: {
        isPapirmentes() {
            return this.$store.getters.isPapirmentes === true;
        },
        papirmentesValue() {
            return this.$store.getters.isPapirmentes;
        },
        papirmentesUgyfazon() {
            return this.$store.getters.papirmentesUgyfazon;
        },
    },
};
